// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .notification {
  position: relative;
  width: 100%;
  padding: 15px 20px;
  border-radius: 4px;
  color: #000;
  background-color: #f6f3f3;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  opacity: 0;
  transform: translateY(-20px);
  animation: slideDown 0.5s forwards, fadeIn 0.5s forwards;
}
.theme-light .notification.success {
  border-left: 5px solid #28a745;
}
.theme-light .notification.error {
  border-left: 5px solid #dc3545;
}
.theme-light .notification.info {
  border-left: 5px solid #17a2b8;
}
.theme-light .notification.warning {
  border-left: 5px solid #ffc107;
}
.theme-light .notification .notification-icon {
  margin-right: 15px;
  font-size: 20px;
}
.theme-light .notification .notification-message {
  flex: 1 1;
}
.theme-light .notification .notification-close {
  background: none;
  border: none;
  color: inherit;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.theme-light .notification.fade-out {
  animation: fadeOut 0.5s forwards;
}
.theme-dark .notification {
  position: relative;
  width: 100%;
  padding: 15px 20px;
  border-radius: 4px;
  color: #fffef9;
  background-color: #333;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  opacity: 0;
  transform: translateY(-20px);
  animation: slideDown 0.5s forwards, fadeIn 0.5s forwards;
}
.theme-dark .notification.success {
  border-left: 5px solid #28a745;
}
.theme-dark .notification.error {
  border-left: 5px solid #dc3545;
}
.theme-dark .notification.info {
  border-left: 5px solid #17a2b8;
}
.theme-dark .notification.warning {
  border-left: 5px solid #ffc107;
}
.theme-dark .notification .notification-icon {
  margin-right: 15px;
  font-size: 20px;
}
.theme-dark .notification .notification-message {
  flex: 1 1;
}
.theme-dark .notification .notification-close {
  background: none;
  border: none;
  color: inherit;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.theme-dark .notification.fade-out {
  animation: fadeOut 0.5s forwards;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/notifications/notification.scss"],"names":[],"mappings":"AAqBI;ECjBE,kBAAA;EACA,WAAA;EAEA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,UAAA;EACA,4BAAA;EACA,wDAAA;AAHN;AAKM;EAEE,8BAAA;AAJR;AAOM;EAEE,8BAAA;AANR;AASM;EAEE,8BAAA;AARR;AAWM;EAEE,8BAAA;AAVR;AAaM;EACE,kBAAA;EACA,eAAA;AAXR;AAcM;EACE,SAAA;AAZR;AAeM;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAbR;AAiBM;EACE,gCAAA;AAfR;AD1BI;ECjBE,kBAAA;EACA,WAAA;EAEA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,UAAA;EACA,4BAAA;EACA,wDAAA;AA6CN;AA3CM;EAEE,8BAAA;AA4CR;AAzCM;EAEE,8BAAA;AA0CR;AAvCM;EAEE,8BAAA;AAwCR;AArCM;EAEE,8BAAA;AAsCR;AAnCM;EACE,kBAAA;EACA,eAAA;AAqCR;AAlCM;EACE,SAAA;AAoCR;AAjCM;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAmCR;AA/BM;EACE,gCAAA;AAiCR","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.notification {\n    @include themify($themes) {\n      position: relative; // Relative positioning to parent .notifications\n      width: 100%; // Allow notifications to take full width of the parent\n    //   max-width: 300px; // Optional: limit maximum width\n      padding: 15px 20px;\n      border-radius: 4px;\n      color: themed(\"textColor\");\n      background-color: themed(\"bgSoft\");\n      display: flex;\n      align-items: center;\n      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n      opacity: 0;\n      transform: translateY(-20px);\n      animation: slideDown 0.5s forwards, fadeIn 0.5s forwards;\n  \n      &.success {\n        background-color: themed(\"success\");\n        border-left: 5px solid #28a745;\n      }\n  \n      &.error {\n        background-color: themed(\"danger\");\n        border-left: 5px solid #dc3545;\n      }\n  \n      &.info {\n        background-color: themed(\"info\");\n        border-left: 5px solid #17a2b8;\n      }\n  \n      &.warning {\n        background-color: themed(\"warning\");\n        border-left: 5px solid #ffc107;\n      }\n  \n      .notification-icon {\n        margin-right: 15px;\n        font-size: 20px;\n      }\n  \n      .notification-message {\n        flex: 1;\n      }\n  \n      .notification-close {\n        background: none;\n        border: none;\n        color: inherit;\n        font-size: 16px;\n        cursor: pointer;\n        padding: 0;\n        line-height: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n  \n      // Fade-out animation\n      &.fade-out {\n        animation: fadeOut 0.5s forwards;\n      }\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
